// extracted by mini-css-extract-plugin
module.exports = {"thresholdTextField":"NewCommentersConfigContainer-thresholdTextField-0c01f72385456def5b68553d15da01fb"};